module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Summary"
  }, [(!_vm.cart.length) ? _c('div', {
    staticClass: "checkout--page__cart"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('cart.title_noproductsincart')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": '#/list/' + _vm.module_id
    }
  }, [_vm._v(_vm._s(_vm.$t('cart.cta_goback')))])]) : _vm._e(), _vm._v(" "), (_vm.cart.length > 0) ? _c('div', {
    staticClass: "cart"
  }, [_c('div', {
    staticClass: "cart-wrapper"
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('summary.title')))]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "cart-items-list"
  }, [_vm._l((_vm.cart), function(cart_item) {
    return [_c('cart-row', {
      attrs: {
        "cart_item": cart_item,
        "can_remove": true,
        "currency": _vm.currency
      }
    })]
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.display_coupon),
      expression: "display_coupon"
    }],
    staticClass: "coupon-code"
  }, [_c('div', {
    staticClass: "coupon-input"
  }, [_c('div', {
    staticClass: "apply-coupon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('summary.coupon_placeholder')
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.confirm_coupon(_vm.code)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('summary.coupon_cta_apply')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visitor_modifiers && _vm.visitor_modifiers.length > 0),
      expression: "visitor_modifiers && visitor_modifiers.length > 0"
    }]
  }, _vm._l((_vm.visitor_modifiers), function(modifier) {
    return _c('div', {
      staticClass: "active__coupon"
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(modifier.code))])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default coupon--remove",
      on: {
        "click": function($event) {
          _vm.remove_coupon({
            code: modifier.code
          })
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('summary.coupon_cta_remove')))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-calculation"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.discounted == _vm.total),
      expression: "discounted == total"
    }]
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('cart.title_totalamount')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total, _vm.currency)))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.display_coupon && _vm.visitor_modifiers && _vm.visitor_modifiers.length > 0),
      expression: "display_coupon && visitor_modifiers && visitor_modifiers.length > 0"
    }]
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('cart.title_totalamount')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total, _vm.currency)))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.display_coupon && _vm.visitor_modifiers && _vm.visitor_modifiers.length > 0),
      expression: "display_coupon && visitor_modifiers && visitor_modifiers.length > 0"
    }]
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('cart.title_discountedamount')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.discounted, _vm.currency)))])])])])]), _vm._v(" "), (!_vm.showShipping) ? _c('div', {
    staticClass: "cart-total"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('h4', [_vm._v(_vm._s(_vm.$t('summary.title_total')))]), _vm._v(" "), _c('p', {
    staticClass: "total-price"
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.discounted, _vm.currency)))])])])]) : _vm._e(), _vm._v(" "), _c('shipping', {
    attrs: {
      "total": _vm.discounted
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f3e5ec20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/SummaryView.vue
// module id = 271
// module chunks = 1